import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { type AccountListResponse, getAccounts } from '../api';
import type { MetricType } from '../model';

export type AccountsListParams = {
  q?: string;
  unpaid?: boolean;
  overage?: MetricType | 'any';
};

export function useAccounts(params: AccountsListParams = {}, options?: { enabled?: boolean }) {
  return useQuery<AccountListResponse, RequestError>({
    queryKey: queryKeys.accounts.list(params),
    queryFn: ({ signal }) => observableToPromise(getAccounts(params), signal),
    staleTime: 10_000,
    gcTime: 2 * 60_000,
    placeholderData: keepPreviousData,
    enabled: options?.enabled,
  });
}
